import { template as template_86496a1428c646ffa536149207d06e35 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import moment from 'moment-timezone';
import echartsTheme from 'eflex/echarts-theme';
import { waitFor } from '@ember/test-waiters';
import { clone } from 'ramda';
import { t } from 'ember-intl';
import { get } from '@ember/helper';
import EChart from 'eflex/components/e-chart';
import BiNoDataPlaceholder from 'eflex/components/bi/no-data-placeholder';
import Spinner from 'eflex/components/spinner';
export default class FaultCodeSummary extends Component {
    @service
    queryRunner;
    @service
    intl;
    get params() {
        return {
            stationIds: this.args.stationIds,
            startDate: this.args.startDate,
            endDate: this.args.endDate,
            shiftNames: this.args.shiftNames
        };
    }
    getData = task({
        drop: true
    }, waitFor(async (params)=>{
        const oeeFaultCodeQuery = await this.queryRunner.queryWithParams.perform(params, [
            {
                $match: {
                    state: 'faulted',
                    faultCodes: {
                        $exists: true
                    }
                }
            },
            {
                $unwind: {
                    path: '$faultCodes.codes'
                }
            },
            {
                $group: {
                    _id: '$faultCodes.codes.code',
                    totalTimeInState: {
                        $sum: {
                            $dateDiff: {
                                startDate: '$startDate',
                                endDate: '$endDate',
                                unit: 'millisecond'
                            }
                        }
                    },
                    doc: {
                        $first: '$$ROOT'
                    }
                }
            },
            {
                $replaceRoot: {
                    newRoot: {
                        $mergeObjects: [
                            {
                                totalTimeInState: '$totalTimeInState'
                            },
                            '$doc'
                        ]
                    }
                }
            },
            {
                $sort: {
                    totalTimeInState: 1
                }
            }
        ], true);
        const oeeFaultCodes = await this.queryRunner.runQuery.perform('OeeStates', oeeFaultCodeQuery);
        return {
            chartData: this.getEchartOptions(oeeFaultCodes),
            exportData: ()=>this.formatExportData(clone(oeeFaultCodes))
        };
    }));
    oeeFaultCodeData = trackedTask(this, this.getData, ()=>[
            this.params,
            this.args.refresher
        ]);
    getEchartOptions(faultCodeData) {
        return {
            title: {
                text: this.intl.t('bi.chartLabel.faultCodeSummary')
            },
            legend: {
                show: true,
                bottom: 5
            },
            tooltip: {
                trigger: 'axis',
                formatter (params) {
                    const tooltipItems = params.map(({ marker, seriesName, value })=>`${marker} ${seriesName} <span style="float:right;font-weight:bold;">${moment.duration(value, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                            precision: 1,
                            trim: 'both mid'
                        })}</span>`).join('<br>');
                    return `<div style="min-width:200px;">${tooltipItems}</div>`;
                }
            },
            yAxis: {
                type: 'category',
                boundaryGap: true,
                data: faultCodeData.map(({ faultCodes })=>{
                    return `${faultCodes.codes.code}: ${faultCodes.codes.description}`;
                })
            },
            xAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        formatter: (value)=>{
                            return moment.duration(value, 'milliseconds').format('d[d] h[h] m[m] s[s]');
                        }
                    }
                }
            ],
            series: [
                {
                    name: this.intl.t('bi.chartLegend.timeFaulted'),
                    data: faultCodeData.map((item)=>item.totalTimeInState),
                    label: {
                        show: true,
                        position: 'right',
                        color: echartsTheme.colorPalette.biGrey,
                        formatter: (params)=>{
                            return moment.duration(params.value, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                                precision: 1,
                                trim: 'both mid'
                            });
                        }
                    },
                    color: echartsTheme.colorPalette.danger,
                    type: 'bar',
                    xAxisIndex: 0
                }
            ]
        };
    }
    formatExportData(data) {
        data.forEach((faultCode)=>{
            const { totalTimeInState } = faultCode;
            faultCode.totalTimeInState = moment.duration(totalTimeInState, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                precision: 1,
                trim: 'both mid'
            });
            delete faultCode.station;
            delete faultCode.faultCodes;
            delete faultCode._id;
            delete faultCode.startDate;
            delete faultCode.endDate;
            delete faultCode.customButtonColor;
            delete faultCode.button;
            delete faultCode.scheduleHistory;
        });
        return data;
    }
    static{
        template_86496a1428c646ffa536149207d06e35(`
    <div ...attributes>
      {{#if this.oeeFaultCodeData.isRunning}}
        <Spinner @belowSidePanel={{true}} />
      {{else if (get this.oeeFaultCodeData.value.chartData.series '0.data.length')}}
        <div class="row h-100">
          <div class="col d-flex justify-content-between">
            <EChart
              @option={{this.oeeFaultCodeData.value.chartData}}
              @exportData={{this.oeeFaultCodeData.value.exportData}}
              @exportFilename={{t 'bi.chartLabel.faultCodeSummary'}}
              class="h-100 w-100 fault-code-summary-bar-chart"
            />
          </div>
        </div>
      {{else}}
        <BiNoDataPlaceholder />
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
